import {
  useState, useEffect, useRef,
} from 'react';
import mapboxgl from 'mapbox-gl';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
import MapboxWorker from 'worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker';
import bbox from '@turf/bbox';
import { customTheme } from '../components/Map/mapTheme';

mapboxgl.workerClass = MapboxWorker;

const useMap = (drawControls, withGeoCoder = true) => {
  const [tools, setTools] = useState();
  const [centerCoordinates, setCenterCoordinates] = useState({ longitude: 0, latitude: 0, zoom: 0 });
  const mapRef = useRef(null);
  const initializeMap = () => {
    try {
      mapboxgl.accessToken = process.env.REACT_APP_MAP_KEY;

      const mapInstance = new mapboxgl.Map({
        container: mapRef.current, // container id
        style: 'mapbox://styles/yuriiol/clvkx563n01dq01qravcxe1e9', // hosted style id
        center: [0, 0], // starting position
        zoom: 0,
        preserveDrawingBuffer: true,
        boxZoom: false,
        dragRotate: false,
        keyboard: false,
        touchPitch: false,
        touchZoomRotate: false,
      });
      const drawInstance = new MapboxDraw({
        displayControlsDefault: false,
        controls: drawControls,
        userProperties: true,
        styles: customTheme,
        keybindings: false,
        boxSelect: false,
      });
      const geocoderInstance = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl,
        language: 'en-US',
        marker: false,
        placeholder: 'Search...',
      });
      const navInstance = new mapboxgl.NavigationControl({
        showCompass: false,
      });

      mapInstance.addControl(drawInstance);
      mapInstance.addControl(navInstance);
      if (withGeoCoder) {
        mapInstance.addControl(geocoderInstance, 'top-left');
      }
      mapInstance.resize();
      setTools({ map: mapInstance, draw: drawInstance });
    } catch (e) {
      console.log(e);
    }
  };

  // const zoomIn = (polygon) => {
  //   const box = bbox(polygon);
  //   console.log(polygon, 'polygon');
  //   console.log(tools.map.isStyleLoaded(), 'tools.map.isStyleLoaded()');
  //   console.log(box, 'box');
  //   tools.map.fitBounds(box, { padding: { top: 30, bottom: 30, left: 30, right: 30 } });
  // };
  const zoomIn = (polygon) => {
    if (!tools.map) {
      console.error('Map not initialized');
      return;
    }
    if (!polygon) {
      console.error('Invalid polygon data:', polygon);
      return;
    }

    const box = bbox(polygon);

    if (tools.map.isStyleLoaded()) {
      tools.map.fitBounds(box, { padding: { top: 30, bottom: 30, left: 30, right: 30 } });
    } else {
      tools.map.once('style.load', () => {
        setTimeout(() => {
          tools.map.fitBounds(box, { padding: { top: 30, bottom: 30, left: 30, right: 30 } });
        }, 100);
      });
    }
  };

  // center: turf.center(
  //   turf.points([
  //     [box[0], box[1]],
  //     [box[2], box[3]],
  //   ]),
  // ).geometry.coordinates }
  const moveMap = () => {
    setCenterCoordinates({
      longitude: tools.map.getCenter().lng.toFixed(4),
      latitude: tools.map.getCenter().lat.toFixed(4),
      zoom: tools.map.getZoom().toFixed(2),
    });
  };

  useEffect(() => {
    initializeMap();
  }, []);

  return { tools, mapRef, utils: { centerCoordinates, moveMap, zoomIn } };
};

export default useMap;
